<template>
  <el-dialog
    title="订单流转"
    :visible.sync="dialogVisible"
    width="900px"
    @close="handleClose"
  >
    <!-- 流转类型选择 -->
    <div v-if="transferOptions.length > 0">
      <el-radio-group v-model="formData.transferType" class="transfer-options">
        <el-radio
          v-for="option in transferOptions"
          :key="option.value"
          :label="option.value"
        >
          {{ option.label }}
        </el-radio>
      </el-radio-group>

      <!-- 备注输入 -->
      <el-form ref="form" :model="formData">
        <el-form-item
          label="催收负责人"
          prop="dcUserId"
          :rules="[{ required: true, message: '请选择催收负责人' }]"
          v-if="
            formData.transferType ===
            EnumAfterSaleActionType.COLLECTION_FOLLOW_UP
          "
        >
          <SelectAdmin v-model="formData.dcUserId"></SelectAdmin>
        </el-form-item>

<!--        <el-form-item label="备注" prop="flowContent">-->
<!--          <el-input-->
<!--            type="textarea"-->
<!--            :rows="4"-->
<!--            v-model="formData.flowContent"-->
<!--            placeholder="请输入备注"-->
<!--          ></el-input>-->
<!--        </el-form-item>-->
      </el-form>
    </div>

    <!-- 流转历史记录 -->
    <div class="transfer-history">
      <h4 v-if="transferOptions.length > 0">流转记录</h4>
      <tp-table
        :isNeedSerialNumber="true"
        :tableData="historyList"
        :columns="historyColumns"
        :showPagination="false"
        :maxHeight="250"
      />
    </div>

    <div slot="footer" v-if="transferOptions.length > 0">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">
        提交
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getTransferHistoryAPI, submitTransferAPI } from "../api/transfer";
import {
  EnumAfterSaleActionType,
  AfterSaleActionTypeToTextMap,
} from "@/enum/dict/afterSaleOrder";
import SelectAdmin from "@/views/components/select-admin.vue";

const historyColumns = [
  {
    label: "操作人",
    prop: "actionUserName",
    minWidth: "120",
    customRender(h, row) {
      return <p>{row["actionUserName"] || ""}</p>;
    },
  },
  {
    label: "操作时间",
    prop: "createTime",
    minWidth: "180",
    customRender(h, row) {
      return <p>{row["createTime"] || ""}</p>;
    },
  },
  {
    label: "原状态",
    prop: "beforeFlowStatusName",
    minWidth: "120",
    customRender(h, row) {
      return <p>{row["beforeFlowStatusName"] || ""}</p>;
    },
  },
  {
    label: "流转后",
    prop: "afterFlowStatusName",
    minWidth: "120",
    customRender(h, row) {
      return <p>{row["afterFlowStatusName"] || ""}</p>;
    },
  },
  // {
  //   label: "备注",
  //   prop: "flowContent",
  //   minWidth: "200",
  //   customRender(h, row) {
  //     return <p>{row["flowContent"] || ""}</p>;
  //   },
  // },
];

export default {
  name: "OrderTransfer",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orderNo: {
      type: String,
      default: "",
    },
    // 菜单类型：1-客服跟进订单 2-法务诉讼订单 3-委外跟进订单 4-债转订单 5-空置待处理订单 6-售后明细 7-催收跟进订单
    menuType: {
      type: Number,
      required: true,
    },
  },
  components: {
    SelectAdmin,
  },
  data() {
    return {
      dialogVisible: false,
      historyColumns,
      historyList: [],
      formData: {
        transferType: null,
        flowContent: "",
      },
      submitting: false,
      EnumAfterSaleActionType,
    };
  },
  computed: {
    transferOptions() {
      // 根据 menuType 返回对应的流转选项，value 直接使用枚举值
      const optionsMap = {
        1: [
          // 客服跟进订单
          {
            label: AfterSaleActionTypeToTextMap.get(
              EnumAfterSaleActionType.COLLECTION_FOLLOW_UP,
            ),
            value: EnumAfterSaleActionType.COLLECTION_FOLLOW_UP,
          },
        ],
        2: [
          // 法务诉讼订单
          {
            label: AfterSaleActionTypeToTextMap.get(
              EnumAfterSaleActionType.CUSTOMER_SERVICE,
            ),
            value: EnumAfterSaleActionType.CUSTOMER_SERVICE,
          },
          {
            label: AfterSaleActionTypeToTextMap.get(
              EnumAfterSaleActionType.OUTSOURCED,
            ),
            value: EnumAfterSaleActionType.OUTSOURCED,
          },
          {
            label: AfterSaleActionTypeToTextMap.get(
              EnumAfterSaleActionType.DEBT,
            ),
            value: EnumAfterSaleActionType.DEBT,
          },
          {
            label: AfterSaleActionTypeToTextMap.get(
              EnumAfterSaleActionType.IDLE,
            ),
            value: EnumAfterSaleActionType.IDLE,
          },
          {
            label: AfterSaleActionTypeToTextMap.get(
              EnumAfterSaleActionType.NO_LAWSUIT,
            ),
            value: EnumAfterSaleActionType.NO_LAWSUIT,
          },
          {
            label: AfterSaleActionTypeToTextMap.get(
              EnumAfterSaleActionType.LAWSUIT_COMPLETED,
            ),
            value: EnumAfterSaleActionType.LAWSUIT_COMPLETED,
          },
        ],
        3: [
          // 委外跟进订单
          {
            label: AfterSaleActionTypeToTextMap.get(
              EnumAfterSaleActionType.CUSTOMER_SERVICE,
            ),
            value: EnumAfterSaleActionType.CUSTOMER_SERVICE,
          },
          {
            label: AfterSaleActionTypeToTextMap.get(
              EnumAfterSaleActionType.LEGAL,
            ),
            value: EnumAfterSaleActionType.LEGAL,
          },
          {
            label: AfterSaleActionTypeToTextMap.get(
              EnumAfterSaleActionType.DEBT,
            ),
            value: EnumAfterSaleActionType.DEBT,
          },
          {
            label: AfterSaleActionTypeToTextMap.get(
              EnumAfterSaleActionType.IDLE,
            ),
            value: EnumAfterSaleActionType.IDLE,
          },
          {
            label: AfterSaleActionTypeToTextMap.get(
              EnumAfterSaleActionType.OUTSOURCED_COMPLETED,
            ),
            value: EnumAfterSaleActionType.OUTSOURCED_COMPLETED,
          },
        ],
        4: [
          // 债转订单
          {
            label: AfterSaleActionTypeToTextMap.get(
              EnumAfterSaleActionType.CUSTOMER_SERVICE,
            ),
            value: EnumAfterSaleActionType.CUSTOMER_SERVICE,
          },
          {
            label: AfterSaleActionTypeToTextMap.get(
              EnumAfterSaleActionType.LEGAL,
            ),
            value: EnumAfterSaleActionType.LEGAL,
          },
          {
            label: AfterSaleActionTypeToTextMap.get(
              EnumAfterSaleActionType.OUTSOURCED,
            ),
            value: EnumAfterSaleActionType.OUTSOURCED,
          },
          {
            label: AfterSaleActionTypeToTextMap.get(
              EnumAfterSaleActionType.IDLE,
            ),
            value: EnumAfterSaleActionType.IDLE,
          },
          {
            label: AfterSaleActionTypeToTextMap.get(
              EnumAfterSaleActionType.NO_DEBT_TRANSFER,
            ),
            value: EnumAfterSaleActionType.NO_DEBT_TRANSFER,
          },
        ],
        5: [
          // 空置待处理订单
          {
            label: AfterSaleActionTypeToTextMap.get(
              EnumAfterSaleActionType.CUSTOMER_SERVICE,
            ),
            value: EnumAfterSaleActionType.CUSTOMER_SERVICE,
          },
          {
            label: AfterSaleActionTypeToTextMap.get(
              EnumAfterSaleActionType.LEGAL,
            ),
            value: EnumAfterSaleActionType.LEGAL,
          },
          {
            label: AfterSaleActionTypeToTextMap.get(
              EnumAfterSaleActionType.OUTSOURCED,
            ),
            value: EnumAfterSaleActionType.OUTSOURCED,
          },
          {
            label: AfterSaleActionTypeToTextMap.get(
              EnumAfterSaleActionType.DEBT,
            ),
            value: EnumAfterSaleActionType.DEBT,
          },
        ],
        6: [],
        7: [
          // 催收跟进订单
          {
            label: AfterSaleActionTypeToTextMap.get(
                EnumAfterSaleActionType.CUSTOMER_SERVICE,
            ),
            value: EnumAfterSaleActionType.CUSTOMER_SERVICE,
          },
          {
            label: AfterSaleActionTypeToTextMap.get(
                EnumAfterSaleActionType.LEGAL,
            ),
            value: EnumAfterSaleActionType.LEGAL,
          },
        ],
      };
      return optionsMap[this.menuType] || [];
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.resetForm();
        this.getHistoryList();
      }
    },
    dialogVisible(val) {
      if (!val) {
        this.$emit("update:visible", false);
      }
    },
  },
  methods: {
    async getHistoryList() {
      const res = await getTransferHistoryAPI({
        orderNo: this.orderNo,
      });

      this.historyList = res || [];
    },
    resetForm() {
      // 默认选择 transferOptions 中的第一个选项
      this.formData = {
        transferType: this.transferOptions[0]?.value,
        flowContent: "",
      };

      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    async handleSubmit() {
      await submitTransferAPI({
        orderNo: this.orderNo,
        actionType: this.formData.transferType,
        flowContent: this.formData.flowContent,
        dcUserId: this.formData.dcUserId,
      });

      this.$message.success("订单流转成功");

      this.handleClose();

      this.$emit("success", {
        actionType: this.formData.transferType,
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.transfer-options {
  margin-bottom: 20px;

  ::v-deep .el-radio-group {
    display: flex;
    gap: 10px;
  }
}

.transfer-history {
  h4 {
    margin: 0 0 15px 0;
    font-size: 14px;
    font-weight: 600;
    color: #606266;
  }
}
</style>
